import { NavbarStyles as styles } from "../css/styles";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useNavigate  } from 'react-router'
import { AuthContext } from "../context/AuthContext";
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';
import { guideIcon, logoutIcon, profileIcon, settingsWheelIcon } from '../constants/icons';
import classNames from 'classnames';
import logo from '../assets/img/logo.svg'
import logoWhite from '../assets/img/logo-white.svg'
import useDarkMode from '../hooks/useDarkMode'
import { getProfileImage } from '../services/api';
import FeedbackModal from './FeedbackModal';

interface NavbarProps {
  className?: string;
}

const Navbar: React.FC<NavbarProps> = ({ className }) => {

  const { t } = useTranslation();
  const { currentUser, logout } = useContext(AuthContext)
  const isTeacher = currentUser?.mode === 'teacher'
  const [isDarkMode] = useDarkMode()
  const [profileImage, setProfileImage] = useState<string>('');
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error(error);
    }
  };

  //PROFILE IMAGE

  //PRODUCTION VERSION

  // const setImageProfile = async () => {
  //   if (currentUser && currentUser.avatar !== null) {
  //     // Step 1: Check if the avatar is in the public `avatars` folder
  //     const publicAvatarPath = `/avatars/${currentUser.avatar}`;
  //     try {
  //       const publicResponse = await fetch(publicAvatarPath, { method: 'HEAD' });
        
  //       if (publicResponse.ok) {
  //         // Avatar found in the public `avatars` folder
  //         setProfileImage(publicAvatarPath);
  //         return; // Exit the function early as we've set the image
  //       }
  //     } catch (error) {
  //       console.error('Error checking public avatar:', error);
  //     }
  
  //     // Step 2: Check if the image is in IndexedDB
  //     const cachedBlob = await getFromIndexedDB(currentUser.avatar, 'profileFiles');
  
  //     if (cachedBlob) {
  //       const blobUrl = URL.createObjectURL(cachedBlob);
  //       setProfileImage(blobUrl);
  //     } else {
  //       // Step 3: Fetch from the server if not found in public folder or IndexedDB
  //       console.log("Fetching banner from server");
  //       const imgSrc = `/teachers_material/profile/${currentUser.avatar}`;
  //       const response = await fetch(imgSrc);
  
  //       if (!response.ok) {
  //         console.error('Failed to fetch image from server:', response.statusText);
  //         return;
  //       }
  
  //       // Set the profile image and cache it in IndexedDB
  //       setProfileImage(imgSrc);
  //       const blob = await response.blob();
  //       await updateIndexedDBAfterUpload(
  //         String(currentUser.avatar),
  //         blob,
  //         String(currentUser.userId),
  //         'profileFiles'
  //       );
  //     }
  //   }
  // };

  useEffect(() => {
    let isMounted = true;
    let blobUrlRef: string | null = null;
  
    const loadProfileImage = async () => {
      if (!currentUser?.avatar) return;
      if (/^\d/.test(currentUser.avatar)) {
        try {
          const blobUrl = await getProfileImage(currentUser.avatar);
          if (isMounted) {
            setProfileImage(blobUrl);
            blobUrlRef = blobUrl;
          }
        } catch (err: any) {
          console.error("Error loading avatar:", err);
          setProfileImage(`/avatars/default.png`)
        }
      } else {
        if (isMounted) {
          setProfileImage(`/avatars/${currentUser.avatar}`);
        }
      }
    };
  
    loadProfileImage();
  
    return () => {
      isMounted = false;
      if (blobUrlRef) URL.revokeObjectURL(blobUrlRef);
    };
    // eslint-disable-next-line
  }, [currentUser?.avatar]);

  // const setImageProfile = async () => {
  //   if (currentUser && currentUser.avatar) {
  //     // Step 1: Set the direct path for public avatars
  //     const publicAvatarPath = `/avatars/${currentUser.avatar}`;
  //     const img = new Image();
  //     img.src = publicAvatarPath;
      
  //     img.onload = () => {
  //       // Image exists, set it
  //       setProfileImage(publicAvatarPath);
  //       setImageReady(true);
  //     };
  
  //     img.onerror = async () => {

  //         await new Promise(resolve => setTimeout(resolve, 100)); 
       
  //         const imgSrc = `/teachers_material/profile/${currentUser.avatar}`;
  //         const response = await fetch(imgSrc);
  
  //         if (!response.ok) {
  //           console.error('Failed to fetch image from server:', response.statusText);
  //           return;
  //         }
  
  //         setProfileImage(imgSrc);
  //         setImageReady(true);
  //       }
  //   }
  // };

  // useEffect(() => {
  //   if (currentUser?.avatar && authReady) {
  //     setImageProfile();
  //   }
  // }, [currentUser?.avatar, authReady]);

  //DEFINE DROPDOWN FUNCTIONS
  const toggleDropdown = () => setIsDropdownOpen(prev => !prev);
  const closeDropdown = () => setIsDropdownOpen(false);

  //HANDLE OUTSIDE CLICK TO CLOSE DROPDOWN
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeDropdown();
      }
    };
  
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  if (isMobile) {
    return (
      <nav className={styles.navbarMobile}>
        <div className={styles.mobileLogoContainer}>
          <img src={isDarkMode ? logoWhite : logo} alt="logo" className={styles.logo} onClick={() => navigate('/')}/>
        </div>
        <button className={styles.hamburgerMenu} onClick={toggleMobileMenu}>
          ☰
        </button> 
        {isMobileMenuOpen && (
          <div className={styles.mobileMenu}>
            <ul className={styles.mobileNavbarLinks}>
              {!currentUser ? (
                <>
                  <li><Link to="/login" onClick={toggleMobileMenu}>{t('login.title')}</Link></li>
                  <li><Link to="/register" onClick={toggleMobileMenu}>{t('global.signUp')}</Link></li>
                  <li>
                    <LanguageSelector appearance='icon' />
                  </li>
                </>
              ) : (
                <>
                  <li><Link to="/courses" onClick={toggleMobileMenu}>{t('global.courses')}</Link></li>
                  {currentUser.mode === 'student' ? (
                    <li><Link to="/rewards" onClick={toggleMobileMenu}>{t('global.rewards')}</Link></li>
                  ) : (
                    <>
                      <li><Link to="/students" onClick={toggleMobileMenu}>{t('global.students')}</Link></li>
                      <li><Link to="/calendar" onClick={toggleMobileMenu}>{t('global.calendar')}</Link></li>
                      <li><Link to={`/profile/${currentUser.userId}`} onClick={toggleMobileMenu}>{t('global.profile')}</Link></li>
                      <li><Link to="/help" onClick={toggleMobileMenu}>{t('global.help')}</Link></li>
                    </>
                  )}
                  <li><Link to="/settings" onClick={toggleMobileMenu}>{t('settings.title')}</Link></li>
                  <li onClick={() => {handleLogout(); toggleMobileMenu();}}>
                    <Link to="/">{t('global.logOut')}</Link>
                  </li>
                  <li className={styles.mobileDivider} />
                  <li><Link to="/privacy" onClick={toggleMobileMenu}>{t('footer.privacyPolicy')}</Link></li>
                  <li><Link to="/terms" onClick={toggleMobileMenu}>{t('footer.termsOfService')}</Link></li>
                  <li><Link to="/contacts" onClick={toggleMobileMenu}>{t('footer.contactUs')}</Link></li>
                </>
              )}
            </ul>
          </div>
        )}
      </nav>
    );
  }

  return (
    <>
    {feedbackOpen && <FeedbackModal onClose={() => setFeedbackOpen(false)} />}
    <div className={className}>
        <div className={styles.logoContainer}>
          <img src={isDarkMode ? logoWhite : logo} alt="logo" className={styles.logo} onClick={() => navigate('/')}/>
        </div>
        {!currentUser ? (
          <nav className={styles.nonuser}>
            <ul className={styles.nonuserLinks}>
              <li>
                <Link to={"/login"}><h6 className={classNames('global-button', styles.navbarButton)}>{t('login.title')}</h6></Link>
              </li>
              <li>
                <Link to={"/register"}><h6 className={classNames('global-button', styles.navbarButton)}>{t('global.signUp')}</h6></Link>
              </li>
              <li className={styles.languageSelector}>
                <LanguageSelector appearance='icon' />
              </li>
            </ul>
          </nav>
        ) : (
          <nav className={styles.user}>
            <ul className={styles.links}>
              <li>
                <Link to="/courses"><h6>{t('global.courses')}</h6></Link>
              </li>
              {currentUser.mode === 'student' ? (
                <li>
                  <Link to="/rewards"><h6>{t('global.rewards')}</h6></Link>
                </li>
              ) : (
                <>
                  <li>
                    <Link to="/students"><h6>{t('global.students')}</h6></Link>
                  </li>
                  <li>
                    <Link to="/calendar"><h6>{t('global.calendar')}</h6></Link>
                  </li>
                </>
              )}
            </ul>
            <div className={styles.currentUser} ref={dropdownRef}>
              <button
                className={styles.userAvatar}
                onClick={toggleDropdown}
                aria-expanded={isDropdownOpen}
              >
                <img src={profileImage} alt="User Avatar" />
              </button>
              {isDropdownOpen && (
                <div className={styles.dropdownUser} role="menu">
                  <ul>
                    {currentUser.mode === 'teacher' && (
                      <li className={styles.dropdown}>
                        <Link to={`/profile/${currentUser.userId}`} onClick={closeDropdown}>
                          <img src={profileIcon} alt="Profile" />
                          <h6>{t('global.profile')}</h6>
                        </Link>
                      </li>
                    )}
                    <li className={styles.dropdown}>
                      <Link to="/settings" onClick={closeDropdown}>
                        <img src={settingsWheelIcon} alt="Settings" />
                        <h6>{t('settings.title')}</h6>
                      </Link>
                    </li>
                    {isTeacher && (
                      <li className={styles.dropdown}>
                        <Link to="/help" onClick={closeDropdown}>
                          <img src={guideIcon} alt="Guide" />
                          <h6>{t('global.help')}</h6>
                        </Link>
                      </li>
                    )}
                    <li className={styles.dropdownDivider} />
                    <li className={styles.dropdown} onClick={() => { handleLogout(); closeDropdown(); }}>
                      <Link to="/" onClick={closeDropdown}>
                        <img src={logoutIcon} alt="Logout" />
                        <h6>{t('global.logOut')}</h6>
                      </Link>
                    </li>
                    <li className={styles.dropdownDivider} />
                    <li className={styles.dropdown}>
                      <Link to="/privacy" onClick={closeDropdown}>
                        <h6>{t('footer.privacyPolicy')}</h6>
                      </Link>
                    </li>
                    <li className={styles.dropdown}>
                      <Link to="/terms" onClick={closeDropdown}>
                        <h6>{t('footer.termsOfService')}</h6>
                      </Link>
                    </li>
                    <li className={styles.dropdown}>
                      <Link to="/contacts" onClick={closeDropdown}>
                        <h6>{t('footer.contactUs')}</h6>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </nav>
        )}
    </div>
    </>
  );
};

export default Navbar;
